import {XauditModel} from '../xaudit.model';
import {DataARPaymentDistribsModel} from './data-ar-payment-distribs.model';

export class DataARPaymentModel extends XauditModel{

PaymetnID: string;
PatientId: string;
PaymentTransactionDate: Date;
PaymentFrom: string;
PayamentFromContactID: string;
Description: string;
enumARPayementTypeID: string;
enumARPayementCCTypeID: string;
enumARPayementETypeID: string;
PaymentAmount: number;
enumCurrencyID: string;
PaymentReferenceObjectiD: string;
enumPaymentSourceID: string;
PaymentSourceObjectID: string;
PaymentProcessorId: string;
PaymentTransactionId: string;
enumPayemendStatusID: string;
isDistributed: boolean;
DepositARAccountID: string;
TDOPaymentReferenceNumber: string;
enumPaymentTransactionTypeID: string;
LOCID: number;
PatientFullName: string; 
DoctorARLocId: string;   

dataARPaymentDistribs: DataARPaymentDistribsModel[];
}
